import {AxiosInstance} from "axios";
import {getToken} from "../services/authService";

export interface IProps {
    api?: AxiosInstance;
    type: string
    url: string;
    body?: any;
}

export const handleHttp = async (props: IProps) => {
    try {
        let response;

        if(props.type === "post" || props.type === "put") {
            // @ts-ignore
            response = await props.api[props.type](props.url, props.body !== undefined? props.body : null);
        }else {
            // @ts-ignore
            response = await props.api[props.type](props.url);
        }

        return response;
    } catch (e: any) {
        if(e.message !== undefined) {
            throw new Error(e.message);
        }else {
            throw new Error("Erro na conexão com o servidor");
        }
    }
}